import { Operator } from './operator.type';
import { QuestionType } from './question-type.enum';

export const BooleanOperators: Operator[] = ['NOT_EMPTY', 'NOT_SELECTED', 'SELECTED'];
export const NumberOperators: Operator[] = ['GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL'];
export const SingleChoiceOperators: Operator[] = [
  'EQUAL',
  'NOT_EQUAL',
  'POSITION_EQUAL',
  'POSITION_NOT_EQUAL',
  'POSITION_GREATER_THAN',
  'POSITION_SMALLER_THAN',
  'POSITION_GREATER_THAN_OR_EQUAL',
  'POSITION_SMALLER_THAN_OR_EQUAL'
];
export const MultiSelectOperators: Operator[] = [
  'EQUAL_ANY',
  'INCLUDES_ALL',
  'INCLUDES_ANY',
  'NOT_INCLUDES',
  'NOT_INCLUDES_ALL',
  'POSITION_INCLUDES_ANY',
  'NPS_SCORE'
];
export const RangeOperators: Operator[] = ['POSITION_BETWEEN', 'POSITION_NOT_BETWEEN'];
export const TextOperators: Operator[] = ['CONTAINS', 'NOT_CONTAINS'];

export const OperatorByQuestionType: Record<Exclude<QuestionType, QuestionType.InfoPage>, { [type: string]: Operator[] }> = {
  [QuestionType.Heatmap]: { default: [] },
  [QuestionType.Dropdown]: { default: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY'] },
  [QuestionType.Essay]: { default: ['NOT_EMPTY', 'CONTAINS', 'NOT_CONTAINS'] },
  [QuestionType.MultiChoice]: { default: ['INCLUDES_ALL', 'INCLUDES_ANY', 'NOT_INCLUDES', 'NOT_INCLUDES_ALL', 'ONLY_IF'] },
  [QuestionType.FileUpload]: { default: [] },
  [QuestionType.Rating]: {
    default: ['GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL'],
    descriptive: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY']
  },
  [QuestionType.SingleChoice]: { default: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY'] },
  [QuestionType.Input]: {
    default: ['NOT_EMPTY', 'CONTAINS', 'NOT_CONTAINS'],
    // eslint-disable-next-line id-blacklist
    number: ['GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL']
  },
  [QuestionType.Carousel]: { default: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY'] },
  [QuestionType.CarouselMultiChoice]: { default: ['INCLUDES_ALL', 'INCLUDES_ANY', 'NOT_INCLUDES', 'NOT_INCLUDES_ALL', 'ONLY_IF'] },
  [QuestionType.CarouselRating]: {
    default: ['GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL'],
    descriptive: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY']
  },
  [QuestionType.Terminate]: { default: [] },
  [QuestionType.HiddenChoice]: { default: ['INCLUDES_ALL', 'INCLUDES_ANY', 'NOT_INCLUDES', 'NOT_INCLUDES_ALL', 'ONLY_IF'] },
  [QuestionType.AIChat]: { default: [] },
  [QuestionType.NPS]: { default: ['NPS_SCORE', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL'] },
  [QuestionType.Ranking]: {
    default: [
      'POSITION_BETWEEN',
      'POSITION_NOT_BETWEEN',
      'POSITION_EQUAL',
      'POSITION_NOT_EQUAL',
      'POSITION_INCLUDES_ANY',
      'POSITION_GREATER_THAN',
      'POSITION_GREATER_THAN_OR_EQUAL',
      'POSITION_SMALLER_THAN',
      'POSITION_SMALLER_THAN_OR_EQUAL'
    ]
  },
  [QuestionType.RankSort]: {
    default: [
      'POSITION_BETWEEN',
      'POSITION_NOT_BETWEEN',
      'POSITION_EQUAL',
      'POSITION_NOT_EQUAL',
      'POSITION_INCLUDES_ANY',
      'POSITION_GREATER_THAN',
      'POSITION_GREATER_THAN_OR_EQUAL',
      'POSITION_SMALLER_THAN',
      'POSITION_SMALLER_THAN_OR_EQUAL',
      'NOT_SELECTED'
    ],
    descriptive: ['EQUAL', 'NOT_EQUAL', 'EQUAL_ANY'],
    none: ['SELECTED']
  }
};
